import { useState } from "react";
import "@/App.css";
import { Toaster } from "@/components/ui/sonner";
import Header from "@/components/Header";
import Hero from "@/components/Hero";
import About from "@/components/About";
import Branches from "@/components/Branches";
import Membership from "@/components/Membership";
import Trainers from "@/components/Trainers";
import Gallery from "@/components/Gallery";
import CtaBanner from "@/components/CtaBanner";
import Contact from "@/components/Contact";
import Footer from "@/components/Footer";
import EnquiryModal from "@/components/EnquiryModal";

export default function App() {
  const [enquiry, setEnquiry] = useState({ open: false, branch: null });
  const openEnquiry = (branch = null) => setEnquiry({ open: true, branch });

  return (
    <div className="bg-[#0A0A0A] text-white font-body antialiased">
      <Header onJoin={() => openEnquiry()} />
      <main>
        <Hero onJoin={() => openEnquiry()} />
        <About />
        <Branches />
        <Membership onEnquire={openEnquiry} />
        <Trainers />
        <Gallery />
        <CtaBanner onJoin={() => openEnquiry()} />
        <Contact />
      </main>
      <Footer />
      <EnquiryModal
        key={`${enquiry.open}-${enquiry.branch}`}
        open={enquiry.open}
        initialBranch={enquiry.branch}
        onClose={() => setEnquiry({ open: false, branch: null })}
      />
      <Toaster position="top-center" theme="dark" />
    </div>
  );
}
